module.exports = require('./getStoreFromApps')
